<template>
  <az-container>
    <div class="pt-4 pb-4">
      <div class="px-2 pb-4">
        <v-expansion-panel v-for="(proposta, index) in propostas" :key="index" class="mb-3">
          <v-expansion-panel-content>
            <template v-slot:header>
              <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
                <div style="display: flex; align-items: center;">
                  <div>
                    <span class="header-item pr-3">{{ proposta.descricao }}</span>
                    <span v-if="proposta.aptoParaReadequacao" class="pr-3">|</span>

                    <span v-if="proposta.aptoParaReadequacao && isMaiorDesconto">
                      Arremate: <formatador-moeda :valor="proposta.valorTotalProposta || 0" :casas-decimais="casasDecimais"></formatador-moeda> (%)
                    </span>
                    <span v-else-if="proposta.aptoParaReadequacao && !isMaiorDesconto">
                      Arremate: R$ <formatador-moeda :valor="proposta.valorTotalProposta || 0" :casas-decimais="casasDecimais"></formatador-moeda>
                    </span>
                    <span v-if="proposta.valorTotalReadequado > 0" class="pr-3 pl-3">|</span>
                    <span v-if="proposta.valorTotalReadequado > 0 && isMaiorDesconto" :class=" classCSSValorTotalProposta(proposta)">
                      Readequação: <formatador-moeda :valor="proposta.valorTotalReadequado || 0" :casas-decimais="casasDecimais"></formatador-moeda> (%)
                    </span>
                    <span v-else-if="proposta.valorTotalReadequado > 0 && !isMaiorDesconto" :class=" classCSSValorTotalProposta(proposta)">
                      Readequação: R$ <formatador-moeda :valor="proposta.valorTotalReadequado || 0" :casas-decimais="casasDecimais"></formatador-moeda>
                    </span>
                  </div>
                </div>
                <span v-if="proposta.aptoParaReadequacao" class="vermelho pr-3" style="margin-left: auto;">
                  Readequação Pendente: {{ tempoFormatado(proposta.tempoRestante) }}
                </span>
              </div>
            </template>
            <tabela-propostas-fornecedor-reajuste class="pb-2" :proposta="proposta" :casas-decimais="casasDecimais" :casas-decimais-sem-regra="casasDecimaisSemRegra"
                                                  :headers="headers" :isMaiorDesconto="isMaiorDesconto" :isValorTotal="isValorTotal" :tipoDisputa="tipoDisputa" @enviar-readequacao="enviarReadequacao">
            </tabela-propostas-fornecedor-reajuste>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </div>
    </div>
    <v-dialog :value="exibirModalConfirmarEnvioReadequacao" persistent max-width="500" non-linear>
      <v-card>
        <v-card-title class="primary modal-title py-2" primary-title>
          Confirmar Alteração
        </v-card-title>
        <v-card-text style="color: #777">
          <div style="text-align: center; width: 100%">Atenção!</div>
          Você confirma o envio da readequação da proposta?
          <br>
          Ao confirmar, a readequação será enviada para seu repectivo item.
          <strong style="color: #3a3939">Esta ação não poderá ser desfeita.</strong>
          Deseja continuar?
        </v-card-text>
        <v-card-actions class="acoes justify-space-between pb-2">
          <v-btn class="mx-2" color="#777" style="border: 1px solid grey" flat
                 @click="fecharModalConfirmar()">
            Voltar
          </v-btn>
          <v-btn class="mx-2 primary confirmar" flat @click="confirmarEnvioReadequacaoProposta(propostaSelected)">
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog :value="exibirModalItemVazioEnvioReadequacao" persistent max-width="500" non-linear>
      <v-card>
        <v-card-title class="primary modal-title py-2" primary-title>
          <div style="text-align: center; width: 100%">Confirmar Alteração</div>
        </v-card-title>
        <v-card-text style="color: #777">
          <div style="text-align: center; width: 100%"><b>Nem todos os itens do tipo possuem um valor preenchido.</b></div>
          <br>
          <div style="text-align: center; width: 100%"><b>Deseja continuar?</b></div>
        </v-card-text>
        <v-card-actions class="acoes justify-space-between pb-2">
          <v-btn class="mx-2" color="#777" style="border: 1px solid grey" flat
                 @click="fecharModalItemVazioEnvioReadequacao()">
            Voltar
          </v-btn>
          <v-btn class="mx-2 primary confirmar" flat @click="confirmarModalItemVazioEnvioReadequacaoProposta(propostaSelected)">
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </az-container>
</template>

<script>
import TabelaPropostasFornecedorReajuste from "@/commons/components/TabelaPropostasFornecedorReajuste.vue";
import {actionTypes, tiposLicitacao, tiposDisputa} from '@/commons/constants';
import {mapActions, mapState} from "vuex";
import accounting from "accounting";
import FormatadorMoeda from "@/commons/components/FormatadorMoeda.vue";

export default {
  components: {TabelaPropostasFornecedorReajuste, FormatadorMoeda},
  data() {
    return {
      exibirModalConfirmarEnvioReadequacao: false,
      exibirModalItemVazioEnvioReadequacao: undefined,
      confirmouValoresReadequacao: false,
      licitacaoId:undefined,
      propostas: [],
      intervalos: null,
      propostaSelected: null,
      casasDecimais: 2,
      casasDecimaisSemRegra: 2,
      tipoDisputa: null,
    };
  },

  computed:{
    isMaiorDesconto() {
      return tiposLicitacao[this.licitacao.tipoLicitacao] === tiposLicitacao.MD ||
          tiposLicitacao[this.licitacao.tipoLicitacao] === tiposLicitacao.MRO ||
          tiposLicitacao[this.licitacao.tipoLicitacao] === tiposLicitacao.MT
    },
    isValorTotal() {
      return tiposDisputa[this.licitacao.tipoDisputa] === tiposDisputa.VALOR_TOTAL
    },
    tempoFormatado() {
      return (segundos) => {
        if (!segundos || segundos <= 0) return "00:00:00";
        const horas = String(Math.floor(segundos / 3600)).padStart(2, '0');
        const minutos = String(Math.floor((segundos % 3600) / 60)).padStart(2, '0');
        const segundosRestantes = String(segundos % 60).padStart(2, '0');
        return `${horas}:${minutos}:${segundosRestantes}`;
      };
    },
    headers(){
      if(this.isMaiorDesconto){
        return [
          {text: 'Codigo', value: 'codigoItem', width:"50px", sortable: false, class: 'primary--text'},
          {text: 'Sequencial', value: 'sequencial', width:"50px", sortable: false, class: 'primary--text'},
          {text: 'Descrição', value: 'descricao', sortable: false, class: 'primary--text'},
          {text: 'Quantidade', value: 'quantidade', width:"70px", sortable: false, class: 'primary--text'},
          {text: 'Marca', value: 'marca', width:"100px", sortable: false, class: 'primary--text'},
          {text: 'Modelo', value: 'modelo', width:"100px", sortable: false, class: 'primary--text'},
          {text: 'Desconto (%)', value: 'valorUnitario', width:"100px", sortable: false, class: 'text-xs-right primary--text'},
          {text: 'Unitário Readequado (%)', value: 'valorUnitarioReadequado', width:"100px", sortable: false, class: 'text-xs-right primary--text'},
        ]
      } else {
        return [
          {text: 'Codigo', value: 'codigoItem', width:"50px", sortable: false, class: 'primary--text'},
          {text: 'Sequencial', value: 'sequencial', width:"50px", sortable: false, class: 'primary--text'},
          {text: 'Descrição', value: 'descricao', sortable: false, class: 'primary--text'},
          {text: 'Quantidade', value: 'quantidade', width:"70px", sortable: false, class: 'primary--text'},
          {text: 'Marca', value: 'marca', width:"100px", sortable: false, class: 'primary--text'},
          {text: 'Modelo', value: 'modelo', width:"100px", sortable: false, class: 'primary--text'},
          {text: 'Valor Unitário', value: 'valorUnitario', width:"100px", sortable: false, class: 'text-xs-right primary--text'},
          {text: 'Valor Total', value: 'valorTotal', width:"100px", sortable: false, class: 'text-xs-right primary--text'},
          {text: 'Unitário Readequado', value: 'valorUnitarioReadequado', width:"100px", sortable: false, class: 'text-xs-right primary--text'},
          {text: 'Total Un. Readequado', value: 'totalReadequado', width:"100px", sortable: false, class: 'text-xs-right primary--text'}
        ]
      }
    },
    ...mapState(['licitacao'])
  },

  async mounted() {
    this.setLicitacaoId(this.$route.params.id)
    await this.buscarPropostas()
    this.iniciarContadores()
  },

  beforeDestroy() {
    Object.values(this.intervalos).forEach(clearInterval);
  },

  methods: {
    async buscarPropostas() {
      const response = await this.buscarPropostasFornecedor(this.licitacaoId)
      this.propostas = response.propostas.map(proposta => ({
        ...proposta,
        tempoRestante: proposta.tempoLimiteReadequacao || 0,
      }))
      this.casasDecimais = response.casasDecimais
      this.casasDecimaisSemRegra = response.casasDecimaisSemRegra
      this.tipoDisputa = response.tipoDisputa
      this.formatarValorUnitarioItensReadequado()
    },

    formatarValorUnitarioItensReadequado() {
      this.propostas.filter(proposta => proposta.aptoParaReadequacao).forEach(proposta => {
        proposta.itens.forEach(item => {
          if (item.valorUnitarioReadequado) {
            item.valorUnitarioReadequado = accounting.formatNumber(item.valorUnitarioReadequado, this.casasDecimaisSemRegra, '.', ',')
          }
          item.marcaOriginal = item.marca
          item.modeloOriginal = item.modelo
        })
      })
    },

    confirmarEnvioReadequacaoProposta(proposta) {
      this.confirmouValoresReadequacao = true
      this.enviarReadequacao(proposta)
    },

    confirmarModalItemVazioEnvioReadequacaoProposta(proposta) {
      this.exibirModalItemVazioEnvioReadequacao = false
      this.enviarReadequacao(proposta)
    },

    fecharModalItemVazioEnvioReadequacao() {
      this.exibirModalItemVazioEnvioReadequacao = undefined
    },

    fecharModalConfirmar() {
      this.exibirModalConfirmarEnvioReadequacao = false
      this.exibirModalItemVazioEnvioReadequacao = undefined
    },

    precisaConfirmarEnvioReadequacao() {
      return !this.confirmouValoresReadequacao
    },

    converterParaNumero(valor) {
      if (typeof valor !== "string") return NaN;

      // Remove os pontos (separadores de milhar) e substitui a vírgula pelo ponto decimal
      let numeroConvertido = valor.replace(/\./g, "").replace(",", ".");

      return parseFloat(numeroConvertido);
    },

    todosItensValidos(lista) {
      return lista.every(item => {
        let valorNumerico = this.converterParaNumero(item.valorUnitarioReadequado);
        return !isNaN(valorNumerico) && valorNumerico > 0;
      });
    },

    marcaModeloForamApagados(proposta) {
      return proposta.itens.some(item => {
        const apagouMarca = item.marcaOriginal && item.marcaOriginal.trim() !== '' && (!item.marca || item.marca.trim() === '')
        const apagouModelo = item.modeloOriginal && item.modeloOriginal.trim() !== '' && (!item.modelo || item.modelo.trim() === '')
        return apagouMarca || apagouModelo
      })
    },

    enviarReadequacao(proposta) {
      this.propostaSelected = proposta

      if (this.marcaModeloForamApagados(proposta)) {
        this.mostrarNotificacaoErro('A marca e o modelo do item não podem ser apagados, apenas editados.')
        return
      }

      if (!this.todosItensValidos(proposta.itens) && this.exibirModalItemVazioEnvioReadequacao === undefined) {
        this.exibirModalItemVazioEnvioReadequacao = true
        return
      }

      if (this.precisaConfirmarEnvioReadequacao()) {
        this.exibirModalConfirmarEnvioReadequacao = true
        return
      }

      const request = {
        proposta: {
          idProposta: proposta.idProposta,
          valorTotalReadequado: Number(proposta.valorTotalReadequado.toFixed(this.casasDecimais)),
          itens: proposta.itens.map(subItem => {
            return {
              idItemProposta: subItem.idItemProposta,
              valorUnitarioReadequado: accounting.unformat(subItem.valorUnitarioReadequado, ','),
              marca: subItem.marca,
              modelo: subItem.modelo
            };
          })
        }
      };

      this.limparCampos()

      this.salvarItensReadequados(request).then(responseSalvar => {
        if (responseSalvar.error) {
          this.mostrarNotificacaoErro(responseSalvar.message)
        } else {
          request.proposta.ajusteValor = responseSalvar.data && responseSalvar.data.ajusteValor
          request.proposta.ajusteMarcaModelo = responseSalvar.data && responseSalvar.data.ajusteMarcaModelo

          this.enviarPropostasReadequadas(request).then(responseEnviar => {
            if (responseEnviar.error) {
              this.mostrarNotificacaoErro(responseEnviar.message)
            } else {
              this.mostrarNotificacaoSucessoDefault()
            }
          }).finally(() => {
            this.buscarPropostas()
          })
        }
      })
    },

    limparCampos() {
      this.exibirModalConfirmarEnvioReadequacao = false
      this.confirmouValoresReadequacao = false
    },

    setLicitacaoId(licitacaoId) {
      this.licitacaoId = licitacaoId
    },

    classCSSValorTotalProposta(proposta) {
      if (proposta) {
        if(this.validarLoteUnificado(proposta)) return ''
        if (this.isMaiorDesconto) {
          return Number(proposta.valorTotalReadequado.toFixed(this.casasDecimais)) < Number(proposta.valorTotalProposta.toFixed(this.casasDecimais)) ? 'vermelho' : ''
        } else {
          return Number(proposta.valorTotalReadequado.toFixed(this.casasDecimais)) > Number(proposta.valorTotalProposta.toFixed(this.casasDecimais)) ? 'vermelho' : ''
        }
      }
    },

    validarLoteUnificado(proposta){
      if(!proposta) return false
      return proposta.itens.find(item => item.isUnificado)
    },

    iniciarContadores() {
      this.intervalos = setInterval(() => {
        this.propostas.forEach((proposta, index) => {
          if (proposta.aptoParaReadequacao && proposta.tempoRestante > 0) {
            this.$set(this.propostas[index], "tempoRestante", proposta.tempoRestante - 1);
          }
        });
      }, 1000);
    },

    ...mapActions([
      actionTypes.BUSCAR_PROPOSTAS_FORNECEDOR,
      actionTypes.SALVAR_ITENS_READEQUADOS,
      actionTypes.ENVIAR_PROPOSTAS_READEQUADAS
    ])
  }
};
</script>

<style lang="stylus">
.v-expansion-panel:has(.v-expansion-panel__container)
  .v-expansion-panel__header
    background-color #EBEBEB
  .v-expansion-panel__container
    background-color #EBEBEB !important

.v-expansion-panel:has(.v-expansion-panel__container.v-expansion-panel__container--active)
  border-radius 5px !important
  .v-expansion-panel__header
    background-color #eae8e8
    .header-item
      color: var(--v-primary-base) !important
  .v-expansion-panel__container
    background-color #fafafa !important

.text-decoration-underline
  text-decoration: underline !important

</style>